import AppLayout from "@lib/components/AppComponents/AppLayout";
import { Spin } from "antd";
import styled from "styled-components";

const StyledAppLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.2);
`;

const AppLoader = () => {
  return (
    <AppLayout>
      <StyledAppLoader>
        <Spin />
      </StyledAppLoader>
    </AppLayout>
  );
};

export default AppLoader;
